export const catalog_matrix = [
  {form_key:'billing_option_id', catalog_key:'billing_options'},
  {form_key:'billing_stamps_limit_id', catalog_key:'billing_limits'},
  {form_key:'billing_responsible_id', catalog_key:'billing_responsible'},
]